import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { DefaultThingsToDoGrabber } from './DefaultThingsToDoSidebar';

const DefaultThingsToDoEdit = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorDefaultThingsToDoEdit" */ './DefaultThingsToDoEdit'),
  'DefaultThingsToDoEdit',
);

const DefaultThingsToDoGuest = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorDefaultThingsToDoGuest" */ './DefaultThingsToDoGuest'),
  'DefaultThingsToDoGuest',
);

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const DefaultThingsToDoConfig: CustomJsonComponentConfig = {
  // Tip:
  // Replace this with the URL for the JSONSchema your component data uses.
  // This makes sure PageComponents with this schema will render your components.
  schemaUrl: 'https://withjoy.com/assets/public/schemas/DefaultThingsToDo_v1.3.0.json',
  componentType: 'DefaultThingsToDo',
  adminSidebarComponent: {
    addComponentView: () => null,
    dragComponentView: DefaultThingsToDoGrabber,
    editComponentView: DefaultThingsToDoEdit,
    createComponentView: DefaultThingsToDoEdit,
  },
  guestSiteComponent: DefaultThingsToDoGuest,
};
